import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ViewComponent } from './view.component';

@Component({
    standalone: true,
    template: '',
    styles: [],
})
export class InputComponent<ModelType> extends ViewComponent<ModelType> implements OnChanges, OnInit {
	@Input() placeholder?: string;
	@Input() hideComments = false;
	@Output() modelChange = new EventEmitter<ModelType>();
	@Output() modified = new EventEmitter<{ current: ModelType, previous: ModelType }>();

	initialized = false;

	constructor() {
		super();
	}

	override ngOnInit(): void {
		super.ngOnInit();
	}

	onFocusOut() { }

	onChange(changes?: SimpleChanges) {
		if (!this.initialized) {
			this.modelChange.emit(this.model);
			return;
		}
		if (!changes && !this.vs.dirty.value) {
			// User-initiated change (from template ngModelChange)
			this.vs.dirty.next(true);
		}
		if (this.validate()) {
			this.modelChange.emit(this.model);
			if (changes && changes['model']) {
				this.modified.emit({ previous: changes['model'].previousValue, current: changes['model'].currentValue });
			}
			return;
		}
		else if (this.successOnDanger()) {
			this.modelChange.emit(this.model);
			return;
		}
	}

	override ngOnChanges(changes: SimpleChanges): void {
		this.onChange(changes);
		this.initialized = true;
		super.ngOnChanges(changes);
		if (this.es.has(this.name)) this.onChange(changes);
	}
}
